import React from 'react';

import { LanguageItem, Wrapper } from './LanguageSwitch.styles';

const LanguageSwitch = ({ languages, useFullLabels, props, ...rest }) => {
  const labelEn = useFullLabels ? 'English' : 'EN';
  const labelNl = useFullLabels ? 'Nederlands' : 'NL';

  return (
    <Wrapper {...rest}>
      {languages.map(lang => {
        const { current, language, url } = lang;

        return (
          <LanguageItem key={language} href={url} as="a" isActive={current}>
            {language === 'en-GB' ? labelEn : labelNl}
          </LanguageItem>
        );
      })}
    </Wrapper>
  );
};

export default LanguageSwitch;
